import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import filter from 'lodash/filter';

import { Alert } from '@lightspeed/flame/Alert';
import Text from '@lightspeed/cirrus-text';

import { getData, postData } from 'pages/store/actions/data';
import { entities } from 'pages/store/schema';

import TableMerge from 'pages/containers/TableMerge';
import { getValues, getValue, getMeta, getProcessing, getErrors } from 'pages/store/selectors';
import { actionTypes } from 'pages/store/actions/defaults';
import { showErrors } from 'pages/utils/errors';

const pageSize = { 'page[size]': 50 };

class BrandsMerge extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.dataInit && !nextProps.isLoading) {
      return {
        dataInit: true,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      dataInit: false,
    };

    this.getBrands = this.getBrands.bind(this);
    this.mergeBrands = this.mergeBrands.bind(this);
  }

  componentDidMount() {
    this.getBrands();
  }

  componentDidUpdate(prevProps) {
    const { location, savingErrors } = this.props;

    if (location.search !== prevProps.location.search) {
      this.getBrands();
    }
    if (!prevProps.savingErrors && savingErrors) {
      showErrors(savingErrors);
    }
  }

  getBrands() {
    this.props.getData(`/admin/brands${this.props.location.search}`, { params: { ...pageSize } });
  }

  mergeBrands(ids, onSuccess) {
    const { brand } = this.props;
    return this.props.postData(`/admin/brands/${brand.id}/merge`, { ids }, onSuccess);
  }

  render() {
    const { brand = { attributes: {} }, meta = {}, brands, isLoading, isSaving } = this.props;
    const { dataInit } = this.state;
    const { pagination } = meta;

    return (
      <div>
        <Text heading4 className="cr-pb-1">
          Merge Into:
        </Text>
        {brand.attributes.name ? (
          <Text heading3 className="notranslate" data-test="brand-merge-into-title">
            {brand.attributes.name}
          </Text>
        ) : null}
        <div className="cr-mv-4">
          <Alert type="warning" noCloseBtn>
            <Text bodyLarge>Warning</Text>
            <Text bodySmall data-test="brand-merge-into-text">
              1. You are merging other records into this record{' '}
              <var>{brand.attributes.name ? `(${brand.attributes.name})` : ''}</var>
            </Text>
            <Text bodySmall>2. Select the records you want to merge into this record.</Text>
            <Text bodySmall>
              3. Press Merge at the top of the list to merge the selected records into this record.
            </Text>
          </Alert>
        </div>
        <Text bodySmall bold className="cr-pb-2">
          Select which Brands to merge:
        </Text>
        <TableMerge
          type="brand"
          source={brand}
          getData={this.getBrands}
          data={filter(brands, listBrand => listBrand.id !== brand.id)}
          pagination={pagination}
          entity={entities.brand}
          dataInit={dataInit}
          isLoading={isLoading}
          isSaving={isSaving}
          mergeData={this.mergeBrands}
        />
      </div>
    );
  }
}

BrandsMerge.defaultProps = {
  isLoading: true,
};

BrandsMerge.propTypes = {
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  brand: getValue(entities.brand, ownProps.id)(state),
  brands: getValues(entities.brand)(state),
  meta: getMeta({ entity: entities.brand, list: true })(state),
  isLoading: getProcessing({ entity: entities.brand, list: true, actionType: actionTypes.LOADING })(
    state
  ),
  isSaving: getProcessing({ entity: entities.brand, list: false, actionType: actionTypes.SAVING })(
    state
  ),
  savingErrors: getErrors({ entity: entities.brand, list: false, actionType: actionTypes.SAVING })(
    state
  ),
});

const mapDispatchToProps = dispatch => ({
  getData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.brand, list: true, options, onSuccess })),
  postData: (url, data, onSuccess) =>
    dispatch(postData({ url, payload: data, entity: entities.brand, list: false, onSuccess })),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandsMerge);
